import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domotique',
  templateUrl: './domotique.component.html',
  styleUrls: ['./domotique.component.scss']
})
export class DomotiqueComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
